import React from 'react'
import Text from '../../../components/text/Text'
import TableHeader from '../../../components/table/TableHeader'
import TableItem from '../../../components/table/TableItem'
import WizImage from '../../../components/image/WizImage'
import {useDisplayNumber} from '../../../utils/number'
import TableLayout from '../../../components/table/TableLayout'
import useNavigation from '../../../hooks/useNavigation'
import {useTime} from '../../../utils/time'
import {useTag} from '../../../utils/etc'
import {useImage} from '../../../utils/image'
import {IPro} from '../../../apis/user/getProHistoryList'
import Span from '../../../components/text/Span'

interface IProps {
    className?: string
    data?: IPro[]
}

const ProPaymentTable: React.FC<IProps> = ({className, data}) => {
    const {floorBalance} = useDisplayNumber()
    const {goUserDetail} = useNavigation()
    const {convertUtc0ToUtc9} = useTime()
    const {renderProPaymentColor, renderStateColor} = useTag()
    const {renderThumbnail} = useImage()

    return (
        <div className={className}>
            <TableHeader className={'grid-cols-[1fr_150px_150px_100px_190px] gap-x-[10px] md:hidden'}>
                <Text>Name</Text>
                <Text>Pay Method</Text>
                <Text>
                    Amount<Span className={'text-body3 text-font03'}>(입금액)</Span>
                </Text>
                <Text>Period</Text>
                <Text>End At</Text>
            </TableHeader>

            <TableLayout>
                {data?.map(item => {
                    const isCheckOverEndAt = new Date(item?.end_at).getTime() < new Date().getTime() ? true : false

                    return (
                        <>
                            <TableItem
                                onClick={() => {
                                    goUserDetail(item.user_id)
                                }}
                                key={item.id}
                                className={
                                    'grid-cols-[1fr_150px_150px_100px_190px] gap-x-[10px] md:grid-cols-3 md:gap-x-[20px] md:gap-y-[20px]'
                                }>
                                <div className={'flex items-center gap-x-[5px] md:justify-center md:col-span-3'}>
                                    <WizImage
                                        src={renderThumbnail(item?.thumbnail)}
                                        className={'w-[40px] h-[40px] rounded-full'}
                                    />
                                    <div className={'truncate'}>
                                        <Text className={`font-bold ${isCheckOverEndAt && 'text-font_red'} truncate`}>
                                            {item?.name}
                                        </Text>
                                        {isCheckOverEndAt && <div className={renderStateColor(false)}>Overdue</div>}
                                    </div>
                                </div>
                                <div className={'md:space-y-[5px]'}>
                                    <Text className={'hidden md:block text-ti3 text-font02 text-center'}>
                                        Pay Method
                                    </Text>
                                    <Text className={`${renderProPaymentColor(item?.pay_method)} md:mx-auto`}>
                                        {item?.pay_method}
                                    </Text>
                                </div>
                                <div className={'md:space-y-[5px]'}>
                                    <Text className={'hidden md:block text-ti3 text-font02 text-center'}>
                                        Amount(입금액)
                                    </Text>
                                    <Text className={'text-font02 md:text-center'}>$ {item?.amount}</Text>
                                </div>
                                <div className={'md:space-y-[5px]'}>
                                    <Text className={'hidden md:block text-ti3 text-font02 text-center'}>Period</Text>
                                    <Text className={'text-font02 md:text-center'}>{item?.period} Month</Text>
                                </div>
                                <div className={'md:col-span-3 '}>
                                    <Text className={`text-font02 md:text-center md:text-body3 md:text-font03`}>
                                        <Span className={'hidden md:inline text-body3 text-font03'}>End At : </Span>
                                        {convertUtc0ToUtc9(item?.end_at)}
                                    </Text>
                                </div>
                            </TableItem>
                        </>
                    )
                })}
            </TableLayout>
        </div>
    )
}

export default ProPaymentTable
